import {View} from 'react-native';
import Onomatopeia from '@assets/img/high-five/onomatopeya.png';
import HighFiveLeft from '@assets/img/high-five/highFiveLeft.png';
import HighFiveRight from '@assets/img/high-five/highFiveRight.png';
import {animated, useSpring} from '@react-spring/web'

export const Highfive = () => {
  const springsTop = useSpring({
    from: { y: 60 },
    to: { y: 20 },
  })
  const springsLeft = useSpring({
    from: { x: -30, y: 70 },
    to: { x: 25, y: 70 },
  })
  const springsRight = useSpring({
    from: { x: 10, y: 70 },
    to: { x: -15, y: 70 },
  })
  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
      <animated.img
        src={HighFiveLeft}
        style={{
          width: 250,
          top: 70,
          borderRadius: 8,
          ...springsLeft,
        }}
      />
      <animated.img
        src={Onomatopeia}
        style={{
          top: 70,
          borderRadius: 8,
          ...springsTop,
        }}
      />
      <animated.img
        src={HighFiveRight}
        style={{
          width: 250,
          top: 70,
          borderRadius: 8,
          ...springsRight,
        }}
      />
    </View>
  );
};
